
export const ASYNC_OPEN_INTERNATIONAL_FETCH = 'ITP_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH';
export const ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS = 'ITP_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH_SUCCESS';
export const ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED = 'ITP_InternationalRepTools/ASYNC_OPEN_INTERNATIONAL_FETCH_FAILED';
